import { useState } from 'react'
import Modal from '@material-ui/core/Modal'
import { Box, Typography } from '@material-ui/core'
import FilledButton from '../FilledButton'
import { useStyles } from './styles'

const RejectedReasonPopUp = (props) => {
  const classes = useStyles()
  const { setShowRejectReason, reason } = props
  const [open, setOpen] = useState(true)

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
      >
        <div className={classes.paper}>
          <Box className={classes.header}>
            <Typography className={classes.text}>Rejection Reason</Typography>
          </Box>
          <Typography className={classes.rejectreasonbox}>{reason}</Typography>
          <Box className={classes.options}>
            <FilledButton
              label="Close"
              width="120px"
              height="36px"
              primary={false}
              tertiary={true}
              onClick={() => {
                setOpen(false)
                setShowRejectReason(false)
              }}
            ></FilledButton>
          </Box>
        </div>
      </Modal>
    </div>
  )
}

export default RejectedReasonPopUp
